import { MarketingSection } from "../../components/Section";
import { MarketingSectionIntro } from "../SectionIntro";

export type Props = {
  /** What follows the mission inside the same band: the Donate card */
  children?: React.ReactNode;
  /** The band's colour; the design turns it dark once News comes before it */
  tone?: "light" | "dark";
};

/**
 * Vision and mission, each as its own labelled statement, 64px apart.
 *
 * The design gives them the same shape as every other section opener rather
 * than a shared heading with two paragraphs under it, which is why there are
 * two intros here and no section title above them.
 */
export function MarketingVision({ children, tone = "light" }: Props) {
  return (
    <MarketingSection id="vision" tone={tone}>
      <MarketingSectionIntro
        eyebrow="Vision"
        size="statement"
        heading="We envision a future where practitioners of arts, culture, and social impact have the material and community resources they need to bring forth more equitable worlds that are waiting to be born."
      />
      <MarketingSectionIntro
        eyebrow="Mission"
        size="statement"
        className="pt-2 lg:pt-8"
        heading="We build scalable platforms for arts, culture, and social impact practitioners and grantmakers to find, connect with, and resource their people. We create the conditions for progressive practitioners to transcend isolation and build resilience across sectors."
      />
      {children}
    </MarketingSection>
  );
}

export default MarketingVision;
